import type {
  CustomIfConditionNodeData,
  CustomNode,
} from '@src/components/custom-nodes/types';

/**
  * Removes all usage places of the node to delete
  * @param nodes - array of nodes
  * @param nodeToRemove - node to remove
  * @returns array of nodes
  */
export const removeAllUsagePlacesOfNodeToDelete = (nodes: CustomNode[], nodeToRemove: CustomNode) => {
  nodes.filter((node) => node.type === 'IfConditionNode').forEach((condNode) => {
    if ((condNode.data as CustomIfConditionNodeData).condSourceId === nodeToRemove.id) {
      const condNodeData = condNode.data as CustomIfConditionNodeData;
      condNodeData.condSourceId = '';
      condNodeData.condStatements = condNodeData.condStatements.map((statement) => {
        if (statement.op === 'or') {
          return { op: 'or', value: [] };
        }
        return { op: 'else', value: null };
      });
    }
  })

  return nodes;
}
